import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type {
  IntegrationOverviewService,
  IntegrationsOverviewResponse,
} from '@/types/integrationsOverview'

/** Hub projection: one row per registry service (+ OAuth synthetic rows). */
export function useIntegrationsOverview() {
  return useQuery<IntegrationOverviewService[]>({
    queryKey: ['integrations-overview'],
    queryFn: async () => {
      const data = await apiClient.get<IntegrationsOverviewResponse>(
        '/api/admin/integrations/overview'
      )
      return data.services
    },
  })
}
